import { defineMessages } from '@/i18n'

type CreditsForm = 'one' | 'few' | 'many'

const RU_CREDITS: Record<CreditsForm, string> = {
  one: 'кредит',
  few: 'кредита',
  many: 'кредитов',
}

export const messages = defineMessages({
  ru: {
    // money.ts
    creditsWithWord: (shown: string, form: CreditsForm) => `${shown} ${RU_CREDITS[form]}`,
    // failureText.ts
    reserveReturning:
      'Кредиты предыдущего запуска ещё возвращаются — попробуйте через несколько минут',
    noCredits: 'Не хватает кредитов',
    noCreditsSums: (required: string, balance: string) =>
      `Не хватает кредитов: нужно ${required}, на балансе ${balance}`,
    notConfiguredTitle: 'Функция пока не настроена на этом окружении',
    unavailable: 'Сервис временно недоступен',
    awaitingAnswer: (jobId: number) => `Запуск #${jobId} ждёт вашего ответа`,
    courseBusyRun: (jobId: number) => `Курс занят запуском #${jobId}`,
    validationTitle: 'Проверьте промпт и параметры запуска',
    forbidden: 'Нет прав на этот курс',
    notFound: 'Курс не найден',
    alreadyResumed: 'Запуск уже продолжен',
    startFailed: 'Не удалось запустить запуск',
    // parseStartError.ts
    notConfigured: 'Функция не настроена на этом окружении',
    courseBusy: 'Курс занят',
    validation: 'Проверьте параметры запуска',
    businessFallback: 'Запуск невозможен',
    rejected: 'Запуск отклонён',
    rateLimited: 'Слишком часто, попробуйте позже',
    // translationFailureText.ts
    allTranslated: 'Всё уже переведено',
    noTextYet: 'В курсе пока нет текста — сначала наполните его',
    unsupportedLanguage: 'Этот язык недоступен для перевода',
    translationStorageLimit: 'Курс сегодня хранит один перевод',
    translationUnpublished:
      'Этот язык скрыт из каталога. Сначала включите его показ — потом его можно сделать базовым',
    cannotDeleteSource: 'Базовый язык удалить нельзя — сначала сделайте базовым другой',
    translationNotFound: 'Этого языка у курса уже нет',
    courseLanguageChanged:
      'Язык курса изменился после этого запуска — продолжить нельзя. Запустите перевод заново из меню языка',
    notCancellable: 'Этот запуск нельзя отменить',
    jobAlreadyFinished: 'Запуск уже завершился',
    // resumeFailureText.ts
    nothingToResume: 'Продолжать нечего — все шаги этого запуска уже сделаны.',
    runDidNotStart:
      'Запуск не начался: воркфлоу не проснулся, кредиты не списаны. Запустите заново.',
    generationPlanNotSaved:
      'Генерация оборвалась до того, как план уроков был составлен. Продолжать нечего — запустите генерацию заново.',
    jobTypeNotResumable: 'Этот запуск нельзя продолжить — он не студийный.',
    jobNotYours: 'Это чужой запуск. Продолжить его может только его автор.',
    resumeNoCredits: 'Не хватает кредитов, чтобы продолжить. Пополните баланс.',
    resumeJobInProgress:
      'Продолжить нельзя прямо сейчас — по курсу уже идёт другой запуск. Дождитесь его завершения.',
    resumeN8nUnavailable:
      'Воркфлоу продолжения сейчас не отвечает. Кредиты не списаны, попробуйте ещё раз чуть позже.',
    resumeAlreadyResumed: 'Этот запуск уже продолжён.',
    // jobTypeLabel.ts
    jobCourseGeneration: 'генерация курса',
    jobCourseImageGeneration: 'генерация картинок',
    jobCourseBlockEdit: 'правка блоков',
    jobCourseTranslation: 'перевод',
    jobImageGeneration: 'генерация картинки',
    jobImageEdit: 'правка картинки',
    jobArticleTranslation: 'перевод статьи',
    jobArticleSeo: 'SEO статьи',
    jobUnknown: 'неизвестный тип запуска',
    // translationRun.ts
    runSuccess: 'Перевод завершён',
    runCancelled: 'Перевод отменён',
    runFailed: 'Перевод прервался',
    runImagesFailed: 'Текст переведён, картинки прервались',
    // failedReasonText.ts
    gateExpired:
      'Срок ответа истёк, запуск закрыт. Нарисованные варианты оплачены и остались в ваших ' +
      'файлах — к ним можно вернуться вручную. Чтобы выбрать стиль, запустите отрисовку заново.',
    gateResumeFailed:
      'Ваш ответ принят и записан, но продолжить запуск не удалось. Выбор повторять не надо — ' +
      'нажмите «Продолжить».',
    modelUnusable:
      'Модель не справилась с переводом этого курса, запуск остановлен. Списано только за ' +
      'сделанное — попробуйте запустить перевод позже.',
    courseWentLive:
      'Курс опубликовали во время запуска. Запустите заново — результат попадёт в черновик',
    // imageFailureText.ts
    noTargetsSelected: 'Не выбрано ни одного места',
    allImagesDrawn: 'Все картинки исходного языка уже нарисованы',
    unknownImageTargets: (message: string) => `Не удалось опознать места: ${message}`,
    tooManyImageTargets: 'Не помещается в один запуск — картинок больше, чем разрешено за раз',
    imageStyleRequired: 'Сначала задайте стиль картинок курса',
    tooManyPilotSets: 'Наборов вариантов стиля заказано больше, чем разрешено за один запуск',
    // imageTargetLabel.ts / translationTargetLabel.ts / blockTargetLabel.ts / lessonTargetLabel.ts
    targetCourseBanner: 'Баннер курса',
    targetMascot: (id: string) => `Маскот #${id}`,
    targetLessonImage: (id: string) => `Картинка урока #${id}`,
    targetBlockImage: (id: string) => `Картинка блока #${id}`,
    targetElement: (id: string) => `Элемент блока #${id}`,
    targetCourse: 'Курс',
    targetLesson: (id: string) => `Урок #${id}`,
    targetBlock: (id: string) => `Блок #${id}`,
    targetLessonNumber: (n: number) => `Урок ${n}`,
    // blockEditFailureText.ts
    tooManyBlocks: (message: string) => `Слишком много блоков за один запуск: ${message}`,
    unknownBlocks: (message: string) => `Часть блоков не найдена: ${message}`,
    // translationPublishFailureText.ts
    publishLanguageFailed: 'Не удалось изменить публикацию языка',
    // skipReason.ts
    blockWriteRejected: 'Сервер не принял правку этого блока — повтор упрётся в то же',
    // courseLanguageFailureText.ts
    courseRunInProgress: 'По курсу идёт запуск — дождитесь его окончания',
  },
  en: {
    creditsWithWord: (shown: string) => `${shown} ${shown === '1' ? 'credit' : 'credits'}`,
    reserveReturning:
      'Credits from the previous run are still being returned — try again in a few minutes',
    noCredits: 'Not enough credits',
    noCreditsSums: (required: string, balance: string) =>
      `Not enough credits: ${required} needed, ${balance} available`,
    notConfiguredTitle: 'This feature isn’t set up in this environment yet',
    unavailable: 'Service temporarily unavailable',
    awaitingAnswer: (jobId: number) => `Run #${jobId} is waiting for your answer`,
    courseBusyRun: (jobId: number) => `The course is busy with run #${jobId}`,
    validationTitle: 'Check the prompt and run settings',
    forbidden: 'You don’t have access to this course',
    notFound: 'Course not found',
    alreadyResumed: 'The run has already been resumed',
    startFailed: 'Couldn’t start the run',
    notConfigured: 'This feature isn’t set up in this environment',
    courseBusy: 'The course is busy',
    validation: 'Check the run settings',
    businessFallback: 'The run can’t be started',
    rejected: 'The run was rejected',
    rateLimited: 'Too many requests — try again later',
    allTranslated: 'Everything is already translated',
    noTextYet: 'The course has no text yet — add content first',
    unsupportedLanguage: 'This language isn’t available for translation',
    translationStorageLimit: 'A course can currently have only one translation',
    translationUnpublished:
      'This language is hidden from the catalog. Show it to learners first — then you can make it the source language',
    cannotDeleteSource:
      'The source language can’t be deleted — make another language the source first',
    translationNotFound: 'This course no longer has this language',
    courseLanguageChanged:
      'The course language changed after this run — it can’t be resumed. Start the translation again from the language menu',
    notCancellable: 'This run can’t be cancelled',
    jobAlreadyFinished: 'The run has already finished',
    nothingToResume: 'Nothing to resume — all steps of this run are done.',
    runDidNotStart:
      'The run didn’t start: the workflow didn’t respond and no credits were charged. Start it again.',
    generationPlanNotSaved:
      'Generation stopped before the lesson plan was ready. Nothing to resume — start the generation again.',
    jobTypeNotResumable: 'This run can’t be resumed — it isn’t a studio run.',
    jobNotYours: 'This run belongs to someone else. Only its author can resume it.',
    resumeNoCredits: 'Not enough credits to resume. Top up your balance.',
    resumeJobInProgress:
      'Can’t resume right now — another run is in progress for this course. Wait for it to finish.',
    resumeN8nUnavailable:
      'The resume workflow isn’t responding. No credits were charged — try again a bit later.',
    resumeAlreadyResumed: 'This run has already been resumed.',
    jobCourseGeneration: 'course generation',
    jobCourseImageGeneration: 'image generation',
    jobCourseBlockEdit: 'block edit',
    jobCourseTranslation: 'translation',
    jobImageGeneration: 'image generation',
    jobImageEdit: 'image edit',
    jobArticleTranslation: 'article translation',
    jobArticleSeo: 'article SEO',
    jobUnknown: 'unknown run type',
    runSuccess: 'Translation complete',
    runCancelled: 'Translation cancelled',
    runFailed: 'Translation interrupted',
    runImagesFailed: 'Text translated, but image generation was interrupted',
    gateExpired:
      'Time to respond ran out, so the run was closed. The generated options were paid for and remain in your ' +
      'files — you can go back to them manually. To choose a style, start image generation again.',
    gateResumeFailed:
      'Your answer was saved, but the run couldn’t continue. No need to choose again — ' +
      'click “Resume”.',
    modelUnusable:
      'The model couldn’t handle translating this course, so the run was stopped. You were charged only for ' +
      'what was done — try the translation again later.',
    courseWentLive:
      'The course was published during the run. Start it again — the result will go into the draft',
    noTargetsSelected: 'No images selected',
    allImagesDrawn: 'All source-language images are already generated',
    unknownImageTargets: (message: string) => `Some images couldn’t be identified: ${message}`,
    tooManyImageTargets: 'Too many images for one run — more than allowed at once',
    imageStyleRequired: 'Set the course image style first',
    tooManyPilotSets: 'Too many style option sets for one run',
    targetCourseBanner: 'Course banner',
    targetMascot: (id: string) => `Mascot #${id}`,
    targetLessonImage: (id: string) => `Lesson image #${id}`,
    targetBlockImage: (id: string) => `Block image #${id}`,
    targetElement: (id: string) => `Block element #${id}`,
    targetCourse: 'Course',
    targetLesson: (id: string) => `Lesson #${id}`,
    targetBlock: (id: string) => `Block #${id}`,
    targetLessonNumber: (n: number) => `Lesson ${n}`,
    tooManyBlocks: (message: string) => `Too many blocks for one run: ${message}`,
    unknownBlocks: (message: string) => `Some blocks weren’t found: ${message}`,
    publishLanguageFailed: 'Couldn’t update publishing for this language',
    blockWriteRejected: 'The server rejected the edit to this block — retrying won’t help',
    courseRunInProgress: 'A run is in progress for this course — wait for it to finish',
  },
})
